<script>
import { mapGetters } from "vuex"
import { find } from "lodash"

export default {
  name: "BreadcrumbHelper",
  computed: {
    ...mapGetters({
      categories: "categories/list"
    }),
    currentCategory() {
      if(!this.$route.params.category) return null
      return find(this.categories, ['slug', this.$route.params.category])
    },
    currentChannel() {
      if(!this.$route.params.channel || this.$route.name === 'channels.show' || !this.currentCategory) return null
      return find(this.currentCategory.channels, ['slug', this.$route.params.channel])
    }
  },
}
</script>
